<template>
  <div class="pageContent wider">
    <ProgressBar :value="15" />
    <div class="system-header">
      <div>
        <img src="/img/magic-clipboard@2x.png" alt="Clipboard" />
      </div>
      <div>
        <div class="pageTitle">
          Here's your
          <br />recommended system
        </div>
        <div>
          <div class="text-bold">Our recommendations for</div>
          <div>address</div>
        </div>
      </div>
    </div>

    <EquipmentSummary :equipment="system.equipment" />

    <div class="continue-section">
      <continue-button text="Continue" to="/assessment/checkout" />
      <ModuleNeedHelp />
    </div>
  </div>
</template>

<script>
import EquipmentSummary from "../components/EquipmentSummary.vue";
import ProgressBar from "../components/ProgressBar.vue";
import ModuleNeedHelp from "../components/ModuleNeedHelp.vue";

export default {
  components: {
    EquipmentSummary,
    ProgressBar,
    ModuleNeedHelp
  },
  data: () => ({
    system: {
      equipment: {
        cameras: [],
        essential: [],
        homeAutomation: [],
        environmental: []
      }
    }
  }),
  async mounted() {
    let { data } = await this.$axios.get("/ajax/system");
    this.system = data;
  }
};
</script>

<style lang="scss" scoped>
.pageContent {
  padding: 3rem 1rem;
  min-height: 90vh;
}
.system-header {
  display: flex;
  align-items: center;
  margin-bottom: 4rem;
  img {
    display: block;
    max-width: 115px;
    margin-right: 2.5rem;
  }
}
</style>

<style src="../../sass/components/continue-section.css" scoped></style>
